import Staffs from "../../../hr/personnel/staffs";

// HR staff directory limited to the Laboratory department
export default function LaboratoryStaffs() {
  return <Staffs department="Laboratory" />;
}
